<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    modal-append-to-body
    append-to-body
    destroy-on-close
    width="1100px"
    :close-on-click-modal="false"
    @closed="handelClosed"
    @open="handelOpen"
  >
    <div class="container" v-loading="boxLoading" element-loading-text="正在加载...">
      <h3 class="title">基础信息</h3>
      <couponsTemplate ref="couponsTemplateRef" :form="templateFrom" couponPlatformType="50" :disabled="typeDialog > 1"></couponsTemplate>
      <el-form ref="formRef" :model="form" :rules="rules" label-width="120px">
        <h3 class="title">活动信息</h3>
<!--        <el-form-item label="优惠券类型" prop="type" :class="isDisabled ? 'item-row' : ''">-->
<!--          <el-radio-group @change="changeType" :disabled="disabledList.includes('type')" style="display: flex;flex-direction: column;" v-model="form.type" v-removeAriaHidden>-->
<!--              <el-radio label="FIX_VOUCHER" style="margin-top: 14px;margin-bottom: 10px;">-->
<!--                满减券-->
<!--                <span class="tips">满一定金额后，下单享满减优惠，例:满100减50</span>-->
<!--              </el-radio>-->
<!--              <el-radio label="DISCOUNT_VOUCHER">-->
<!--                折扣券-->
<!--                <span class="tips">满一定金额后，下单享折扣优惠，例:满100打9折</span>-->
<!--              </el-radio>-->
<!--          </el-radio-group>-->
<!--        </el-form-item>-->

        <el-form-item label="活动名称" prop="activityName">
          <el-input :disabled="disabledList.includes('activityName')" v-model="form.activityName" placeholder="请输入活动名称" style="width: 300px;" maxlength="14" show-word-limit></el-input>
          <span class="tips">如十一活动券、周末券，14字以内</span>
        </el-form-item>

        <el-form-item label="活动时间" prop="publishEndTimeArr">
          <el-date-picker
            v-model="form.publishEndTimeArr"
            :disabled="disabledList.includes('publishEndTimeArr')"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            :picker-options="pickerOptions"
          ></el-date-picker>
          <span class="tips">优惠券可以领取的时间</span>
        </el-form-item>

<!--        <el-form-item label="优惠内容" required>-->
<!--          <div style="display: flex;">-->
<!--            <el-form-item prop="floorAmount">-->
<!--              满-->
<!--              <el-input-->
<!--                v-model="form.floorAmount"-->
<!--                :disabled="disabledList.includes('floorAmount')"-->
<!--                placeholder="请输入支付金额"-->
<!--                style="width: 200px; margin-right: 10px;margin-left: 10px;"-->
<!--                class="mtop"-->
<!--              >-->
<!--                <template slot="append">元</template>-->
<!--              </el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item prop="amount" v-if="form.type === 'FIX_VOUCHER'">-->
<!--              ，减-->
<!--              <el-input-->
<!--                v-model="form.amount"-->
<!--                :disabled="disabledList.includes('amount')"-->
<!--                placeholder="请输入满减金额" style="width: 200px; margin-left: 10px;" class="mtop">-->
<!--                <template slot="append">元</template>-->
<!--              </el-input>-->
<!--            </el-form-item>-->
<!--            <div v-else-if="form.type === 'DISCOUNT_VOUCHER'" style="display: flex;">-->
<!--              <el-form-item prop="discount">-->
<!--                ，享-->
<!--                <el-input-->
<!--                  v-model="form.discount"-->
<!--                  :disabled="disabledList.includes('discount')"-->
<!--                  placeholder="请输入折扣值" style="width: 200px; margin-left: 10px;margin-right: 10px;" class="mtop">-->
<!--                  <template slot="append">折</template>-->
<!--                </el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item prop="ceilingAmount">-->
<!--                ，最高优惠-->
<!--                <el-input-->
<!--                  v-model="form.ceilingAmount"-->
<!--                  :disabled="disabledList.includes('ceilingAmount')"-->
<!--                  placeholder="请输入最高优惠金额" style="width: 220px; margin-left: 10px;" class="mtop">-->
<!--                  <template slot="append">元</template>-->
<!--                </el-input>-->
<!--              </el-form-item>-->
<!--            </div>-->
<!--            <div class="tips" v-if="form.type === 'FIX_VOUCHER'">订单金额限制范围:1~1000;减免金额限制范围:1~500</div>-->
<!--          </div>-->
<!--          <div class="tips" style="margin-top: 5px;" v-if="form.type === 'DISCOUNT_VOUCHER'">订单金额限制范围:1~1000;折扣限制在:50~97。最高优惠限制在500元以内</div>-->
<!--        </el-form-item>-->

        <el-form-item label="发放数量" prop="quantity">
          <el-input
            v-model="form.quantity"
            :disabled="disabledList.includes('quantity')"
            placeholder="请输入发放数量" style="width: 200px;" class="mtop"
          >
            <template slot="append">张</template>
          </el-input>
          <span class="tips">限制范围:1~1000张 总预算=¥0 元(优惠金额总发券张数)，发布后可追加，最多追加到100万张</span>
        </el-form-item>

        <el-form-item label="券使用有效期" prop="periodType">
          <el-radio-group
            v-model="form.periodType"
            :disabled="disabledList.includes('periodType')"
            style="display: flex;flex-direction: column;"
            v-removeAriaHidden
            @change="handelChangePeriodType"
          >
            <div style="display: flex;align-items: center;margin-bottom: 15px;">
              <el-radio label="ABSOLUTE" style="width: 80px;">
                固定时间
              </el-radio>
              <el-form-item prop="validTimeArr">
                <el-date-picker
                  v-model="form.validTimeArr"
                  :disabled="disabledList.includes('validTimeArr')"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="margin-left: 10px;width: 410px;"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
              </el-form-item>
            </div>
            <div style="display: flex;align-items: center">
              <el-radio label="RELATIVE" style="width: 80px;">
                领取
              </el-radio>
              <el-form-item prop="waitDaysAfterReceive" style="margin-left: 10px;">
                <el-input
                  v-model="form.waitDaysAfterReceive"
                  :disabled="disabledList.includes('waitDaysAfterReceive')"
                  placeholder="请输入天数"
                  style="width: 120px; margin-right: 10px;"
                >
                </el-input>
                天后生效，有效期
              </el-form-item>
              <el-form-item prop="validDaysAfterReceive">
                <el-input
                  v-model="form.validDaysAfterReceive"
                  :disabled="disabledList.includes('validDaysAfterReceive')"
                  placeholder="请输入天数"
                  style="width: 120px; margin-right: 10px;margin-left: 10px;"
                >
                </el-input>
                天
              </el-form-item>
            </div>
          </el-radio-group>
        </el-form-item>

        <h3 class="title">适用范围</h3>
        <el-form-item label="适用对象" prop="applicableObject">
          <el-radio-group
            v-model="form.applicableObject"
            :disabled="disabledList.includes('applicableObject')"
            v-removeAriaHidden>
            <el-radio :label="0">所有用户</el-radio>
            <el-radio :label="1">新客户专用</el-radio>
            <el-radio :label="2">老客户通用</el-radio>
          </el-radio-group>
        </el-form-item>

        <h3 class="title">发放规则</h3>
        <el-form-item label="领取限制" prop="quantityLimitPerUser">
          <el-input
            v-model="form.quantityLimitPerUser"
            :disabled="disabledList.includes('quantityLimitPerUser')"
            placeholder="请输入领取限制" style="width: 220px;"
            class="mtop"
          >
            <template slot="append">张/人</template>
          </el-input>
          <span class="tips">本次活动每个用户可领取数量，可设置范围1~10，建议设为3</span>

        </el-form-item>

        <el-form-item label="发放方式" prop="giveMethod">
          <el-radio-group
            v-model="form.giveMethod"
            :disabled="disabledList.includes('giveMethod')"
            v-removeAriaHidden
          >
            <el-radio :label="0">客户主动领取</el-radio>
            <span class="tips">仅客户领取</span>
          </el-radio-group>
        </el-form-item>

        <h3 class="title">使用规则</h3>
        <el-form-item label="互斥条件" prop="mutualCondition">
          <el-radio-group
            v-model="form.mutualCondition"
            :disabled="disabledList.includes('mutualCondition')"
            v-removeAriaHidden
          >
            <el-radio :label="0">不与其它优惠共享</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="退款规则" prop="refundRule">
          <el-radio-group v-model="form.refundRule" :disabled="disabledList.includes('refundRule')" v-removeAriaHidden>
            <el-radio :label="0">返回优惠券</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="使用方式" prop="usePrice">
          <el-radio-group v-model="form.usePrice" :disabled="disabledList.includes('usePrice')" v-removeAriaHidden>
            <el-radio :label="0">在市场价基础上优惠</el-radio>
          </el-radio-group>
        </el-form-item>

        <div style="display: flex;margin-bottom: 10px;">
          <h3 class="title" style="margin-right: 30px;">状态</h3>
          <el-switch
            v-model="form.activityStatus"
            :disabled="disabledList.includes('activityStatus')"
            :active-value="0"
            :inactive-value="1">
          </el-switch>
          <span class="tips">默认开启</span>

        </div>

        <h3 class="title">其他</h3>
        <el-form-item label="客服联系方式" prop="customerServiceMobile">
          <el-input v-model="form.customerServiceMobile" :disabled="disabledList.includes('customerServiceMobile')" placeholder="请输入客服联系方式" style="width: 200px;">
          </el-input>
        </el-form-item>
        <el-form-item label="使用须知" prop="remark">
          <div>使用说明仅可描述券的使用规则，例如本优惠券不可转让等</div>
          <el-input
            v-model="form.remark" type="textarea"
            :disabled="disabledList.includes('remark')"
            placeholder="1、本券不可兑换现金，不可找零。
2、本券为单品优惠券，非全场通用，需购买特定商品时才可使用。
3、优惠券仅限在线支付时使用，使用优惠券的账号需为领取时使用的账号。
4 每个优事券只能使用一次，不能暑加或者拆分使用" :rows="4" style="width: 600px;">
          </el-input>
        </el-form-item>


      </el-form>
      <div style="width: 700px;display: flex;flex-direction: row-reverse;">
        <el-button v-if="typeDialog !== 3" type="primary" @click="submitForm" :loading="loading">提交</el-button>
      </div>
    </div>

  </el-dialog>
</template>

<script>
import mini from "@/api/mini";
const MiniModel = new mini();
import {matchInteger} from '@/utils/regExp'
import {formatDate,compareDates} from '@/utils/date'
import debounce from "@/utils/debounce.js";
import couponsTemplate from '@/components/couponsTemplate.vue'
import {useCouponsTemplate,useSetTemplateFrom} from '@/components/useCouponsTemplate.js'


export default {
  components:{
    couponsTemplate
  },
  created() {
    // this.templateFrom = useCouponsTemplate();
    console.log(useCouponsTemplate(),'useCouponsTemplate()')
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      const phoneRegex = /^[1]([3-9])[0-9]{9}$/; // 手机号码正则校验规则
      if (!value) {
        callback(new Error('请输入手机号码'));
      } else if (!phoneRegex.test(value)) {
        callback(new Error('请输入有效的手机号码'));
      } else {
        callback(); // 校验通过
      }
    };
    return {
      templateFrom:useCouponsTemplate(),
      boxLoading:false,
      loading: false,
      typeDialog:'', // 1新增 2编辑 3查看
      title:'新增优惠券',
      dialogVisible: false,
      isDisabled:false, //是否可编辑
      disabledList:[],  // 不可编辑字段
      detaile:{},
      form: {
        type: 'FIX_VOUCHER', //FIX_VOUCHER:满减券 DISCOUNT_VOUCHER:折扣券
        activityName: '',
        publishEndTimeArr: [],
        floorAmount: '',
        amount: '',
        quantity: '',
        periodType: 'ABSOLUTE', //ABSOLUTE:固定时间 RELATIVE:领取后
        validTimeArr: [],
        waitDaysAfterReceive: '',
        validDaysAfterReceive: '',
        applicableObject: 0,
        quantityLimitPerUser: '',
        giveMethod: 0,
        mutualCondition: 0,
        refundRule: 0,
        usePrice: 0,
        activityStatus: 0,
        customerServiceMobile: '',
        remark: '',
        discount:'',
        ceilingAmount:'',
      },
      rules: {
        type: [{ required: true, message: '请选择优惠券类型', trigger: 'change' }],
        activityName: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
        publishEndTimeArr: [
          { type: 'array', required: true, message: '请选择活动时间', trigger: 'change' },
          { validator: this.validateTimeRange, trigger: 'change' }
        ],
        floorAmount: [
          { required: true, message: '请输入支付金额', trigger: 'blur' },
          {
            pattern: /^(?:[1-9][0-9]{0,2}|1000)$/,
            message: "请输入数值，金额限制范围:1~1000",
            trigger: ["blur", "change"],
          },
        ],
        // discount: [{ required: true, message: '请输入折扣值', trigger: 'blur' }],
        // ceilingAmount: [{ required: true, message: '请输入最高优惠金额', trigger: 'blur' }],
        // amount: [{ required: true, message: '请输入优惠金额', trigger: 'blur' }],
        amount:[],
        discount:[],
        ceilingAmount:[],
        quantity: [
          { required: true, message: '请输入发放数量', trigger: 'blur' },
          {required:true,validator:this.validateQuantity, trigger: ["blur", "change"]}
          // {
          //   pattern: /^(?:[1-9][0-9]{0,2}|1000000)$/,
          //   message: "请输入数值，限制范围:1~1000000张",
          //   trigger: ["blur", "change"],
          // },
        ],
        periodType: [{ required: true, message: '请选择券使用有效期', trigger: 'change' }],
        // validTimeArr: [{ type: 'array', required: true, message: '请选择固定时间', trigger: 'change' }],
        validTimeArr: [],
        waitDaysAfterReceive: [],
        validDaysAfterReceive: [],
        // waitDaysAfterReceive: [{ required: true, message: '请输入生效天数', trigger: 'blur' }],
        // validDaysAfterReceive: [{ required: true, message: '请输入有效期天数', trigger: 'blur' }],
        applicableObject: [{ required: true, message: '请选择适用对象', trigger: 'change' }],
        quantityLimitPerUser: [
          { required: true, message: '请输入领取限制', trigger: 'change' },
          {
            pattern: /^(?:[1-9]|10)$/,
            message: "请输入数值，可设置范围1~10",
            trigger: ["blur", "change"],
          },
        ],
        giveMethod: [{ required: true, message: '请选择发放方式', trigger: 'change' }],
        mutualCondition: [{ required: true, message: '请输入互斥条件', trigger: 'blur' }],
        refundRule: [{ required: true, message: '请输入返还优惠券内容', trigger: 'blur' }],
        usePrice: [{ required: true, message: '请输入市场价格', trigger: 'blur' }],
        activityStatus: [{ required: true, message: '请选择状态', trigger: 'change' }],
        customerServiceMobile: [
          { required: true, message: '请输入服务联系人', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        remark: [{ required: true, message: '请输入使用规则', trigger: 'blur' }],

      },
      pickerOptions:{
        disabledDate(time) {
          // 时间范围，今天之前的日期不可选
          const today = new Date().setHours(0, 0, 0, 0);
          return time.getTime() < today;
        },
      }
    };
  },
  watch:{
    'form.type':{
      handler(newVal,oldVal){
        // console.log('newVal,oldVal==1',newVal,'newVal,oldVal==1')
        if(newVal === 'FIX_VOUCHER') {
          this.$set(this.rules,'amount',[
            { required: true, message: '请输入优惠金额', trigger: 'blur' },
            {
              pattern: /^([1-9][0-9]?|[1-4][0-9]{2}|500)$/,
              message: "请输入数值，金额限制范围:1~500",
              trigger: ["blur", "change"],
            }
          ])
          this.$set(this.rules,'discount',[])
          this.$set(this.rules,'ceilingAmount',[])
          this.$nextTick(() => {
            // 清空表单校验
            if(this.$refs.formRef){
              this.$refs.formRef.clearValidate(['discount','ceilingAmount'])
            }
          })
        } else {
          this.$set(this.rules,'amount',[])
          this.$set(this.rules,'discount',[
            { required: true, message: '请输入折扣值', trigger: 'blur' },
            {
              pattern: /^(5[0-9]|6[0-9]|7[0-9]|8[0-9]|9[0-7])$/,
              message: "请输入数值，请输入数值，折扣限制在:50~97",
              trigger: ["blur", "change"],
            }
          ])
          this.$set(this.rules,'ceilingAmount',[
            { required: true, message: '请输入最高优惠金额', trigger: 'blur' },
            {
              pattern: /^([1-9][0-9]?|[1-4][0-9]{2}|500)$/,
              message: "请输入数值，金额限制范围:1~500",
              trigger: ["blur", "change"],
            }
          ])
          this.$nextTick(() => {
            if(this.$refs.formRef){
              this.$refs.formRef.clearValidate(['amount'])
            }
          })
        }
      },
      immediate:true
    },
    'form.periodType':{
      handler(newVal,oldVal){
        // console.log('newVal,oldVal==3',newVal,'newVal,oldVal==3')
        console.log(this.typeDialog,'this.typeDialog==3')
        if(newVal === 'ABSOLUTE') {
          this.$set(this.rules,'validTimeArr',[
            { type: 'array', required: true, message: '请选择固定时间', trigger: 'change' },
            { validator: this.validateTimeArrRange, trigger: 'change' }
          ])
          this.$set(this.rules,'waitDaysAfterReceive',[
            { required: false, message: '请输入生效天数', trigger: 'change' },
          ])
          this.$set(this.rules,'validDaysAfterReceive',[
            { required: false, message: '请输入有效期天数', trigger: 'change' },
          ])
          this.$nextTick(() => {
            if(this.$refs.formRef) {
              this.$refs.formRef.clearValidate(['waitDaysAfterReceive','validDaysAfterReceive'])
            }
          })
        } else {
          this.$set(this.rules,'validTimeArr',[])
          this.$set(this.rules,'waitDaysAfterReceive',[
            { required: true, message: '请输入生效天数', trigger: 'change' },
            {
              pattern: matchInteger,
              message: "请输入正整数",
              trigger: ["blur", "change"],
            }
          ])
          this.$set(this.rules,'validDaysAfterReceive',[
            { required: true, message: '请输入有效期天数', trigger: 'change' },
            {
              pattern: matchInteger,
              message: "请输入正整数",
              trigger: ["blur", "change"],
            }
          ])
          console.log(this.detaile,'this.detaile==3')
          // 编辑时，校验
          if(this.typeDialog === 2) {
            this.rules.waitDaysAfterReceive.push({
              validator: (rule, value, callback) => {
                if (value > this.detaile.waitDaysAfterReceive) {
                  callback(new Error("请输入小于等于原生效天数" + this.detaile.waitDaysAfterReceive+"的值"));
                } else {
                  callback();
                }
              },
              trigger: ["blur", "change"],
            })
            this.rules.validDaysAfterReceive.push({
              validator: (rule, value, callback) => {
                if (value < this.detaile.validDaysAfterReceive) {
                  callback(new Error("请输入大于等于原始值" + this.detaile.validDaysAfterReceive));
                } else {
                  callback();
                }
              },
              trigger: ["blur", "change"],
            })
          }
          this.$nextTick(() => {
            if(this.$refs.formRef){
              this.$refs.formRef.clearValidate(['validTimeArr'])
            }
          })

        }
      },
      immediate:true
    }
  },
  methods: {
    changeType(val) {
      console.log(val,'val==2345')
      this.resetFrom()
      this.form.type = val
    },
    // 自定义校验规则，校验时间范围是否大于当前时间
    validateTimeRange(rule, value, callback) {
      if (!value || value.length !== 2) {
        return callback(new Error('请选择活动时间'));
      }

      const [startTime, endTime] = value;
      console.log(startTime, endTime,'startTime, endTime=12')
      const now = new Date().getTime(); // 当前时间的时间戳
      console.log(new Date(endTime).getTime(),now,'时间比较==12345===',now > new Date(startTime).getTime())
      // if (new Date(startTime).getTime() <= now) {
      //   return callback(new Error('开始时间必须大于当前时间'));
      // }
      console.log(this.typeDialog,'this.typeDialog===validateTimeRange')
      if(this.typeDialog === 2) {
        let timeSTart = this.detaile.publishStartTime
        let timeEnd = this.detaile.publishEndTime
        console.log(this.detaile.publishStartTime,'活动时间开始=旧')
        console.log(new Date(startTime).getTime(),new Date(timeSTart).getTime(),'SDFDSS')
        // 活动已经开始
        if(now > new Date(timeSTart).getTime()) {
          if(new Date(startTime).getTime() !== new Date(timeSTart).getTime()) {
            return callback(new Error('活动已开始，开始时间不可修改：'+timeSTart));
          }
        }
        if(new Date(timeEnd).getTime() > new Date(endTime).getTime()){
          return callback(new Error('结束时间必须晚于原始时间：'+timeEnd));
        }
      }
      if (new Date(endTime).getTime() <= now) {
        return callback(new Error('结束时间必须大于当前时间：'+formatDate('yyyy-MM-dd hh:mm:ss')));
      }
      return callback(); // 校验通过
    },
    // 有效期固定时间开始时间 > 活动时间开始时间。有效期固定时间结束时间 > 活动时间结束时间
    validateTimeArrRange(rule, value, callback) {
      console.log(this.typeDialog,'this.typeDialog====')
      if (!value || value.length !== 2) {
        return callback(new Error('请选择固定时间'));
      }
      if(this.form.publishEndTimeArr.length !== 2) {
        return callback();
      }
      const [startTime, endTime] = value;
      console.log(compareDates(startTime,this.form.publishEndTimeArr[0]),'CCC')
      if(this.typeDialog === 2){
        let validStart = this.detaile.validBeginTime
        let validEnd = this.detaile.validEndTime
        if(new Date(validStart).getTime() < new Date(startTime).getTime()) {
          return callback(new Error('有效期固定开始时间必须早于原始开始时间：'+validStart));
        }
        if(new Date(validEnd).getTime() > new Date(endTime).getTime()) {
          return callback(new Error('有效期固定结束时间必须晚于原始结束时间：'+validEnd));
        }
      }
      if (compareDates(startTime,this.form.publishEndTimeArr[0]) === 2) {
        return callback(new Error('有效期固定开始时间不能早于活动时间开始时间：'+this.form.publishEndTimeArr[0]));
      }
      if (compareDates(this.form.publishEndTimeArr[1], endTime) === 1) {
        return callback(new Error('有效期固定结束时间不能早于活动时间结束时间：'+this.form.publishEndTimeArr[1]));
      }
      return callback(); // 校验通过
    },
    validateQuantity(rule, value, callback){
      let num = this.typeDialog === 1 ? 1000 : 1000000
      if (value === '' || value === undefined || value === null || value == 0) {
        callback(new Error('请输入发放数量'));
      } else if (!/^\d+(\.\d+)?$/.test(value)) {
        callback(new Error('请输入正数'));
      } else if (Number(value) > num) {
        callback(new Error(`请输入数值，限制范围:1~${num}张`));
      } else {
        callback();
      }
    },
    async openDialog(type,row) {
      console.log(type,row,'type,row==222')
      this.disabledList = []
      this.boxLoading = true
      this.dialogVisible = true;
      this.typeDialog = type
      this.$nextTick(() => {
        this.$refs.couponsTemplateRef.open()
      })
      if(type === 1) {
        this.title = '新增优惠券'
        this.detaile = {}
        this.resetFrom()
        this.disabledList = ['activityStatus']
        this.$nextTick(() => {
          this.$refs.couponsTemplateRef.resetForm()
        })
      }else if(type === 2) {
        this.title = '编辑优惠券'
        await this.getDetaile(row)
        this.disabledList =
          ['type','floorAmount','amount','discount','ceilingAmount','quantity','applicableObject','giveMethod','mutualCondition','refundRule','usePrice','activityStatus']
        // this.form = Object.assign({},row)
        if(this.detaile.periodType === 'ABSOLUTE') {
          this.disabledList = this.disabledList.concat(['periodType','waitDaysAfterReceive','validDaysAfterReceive'])
        }else if(this.detaile.periodType === 'RELATIVE') {
          this.disabledList = this.disabledList.concat(['periodType','validTimeArr'])
        }
      }else if(type === 3) {
        this.title = '查看优惠券'
        Object.keys(this.form).forEach(key=> {
          this.disabledList.push(key)
        })
        await this.getDetaile(row)
      }
      this.boxLoading = false
      // loading.close()
      this.$nextTick(() => {
        this.$refs.formRef.clearValidate()
      })
    },
    // 获取详情
    async getDetaile(row) {
      const res = await MiniModel.zfbActivityDetailMarket({
        appKey: localStorage.getItem("appKeyMini"),
        id: row.id
      })

      if(res.data.code === 200) {
        // this.form = Object.assign({},res.data.data)
        let data = res.data.data
        console.log(data,'res==1=优惠券')
        Object.keys(this.form).forEach(key => {
          if(key === 'publishEndTimeArr') {
            this.form.publishEndTimeArr = [data.publishStartTime,data.publishEndTime]
          }else if(key === 'validTimeArr') {
            if(data.periodType === 'ABSOLUTE') {
              this.form.validTimeArr = [data.validBeginTime,data.validEndTime]
            }else{
              this.form.validTimeArr = []
            }
          }else if(key === 'floorAmount') {
            this.form.floorAmount = data.floorAmountBd
          }else if(key === 'amount') {
            this.form.amount = data.amountBd
          }else if(key === 'ceilingAmount') {
            this.form.ceilingAmount = data.ceilingAmountBd
          }else if(key === 'templateVo') {

          }else{
            this.form[key] = data[key]
          }
        })
        this.detaile = data
        this.templateFrom = useSetTemplateFrom(data.templateVo)
        console.log(this.form,'this.form==1详情')
      }else{
        this.$message({
          message: res.data.message,
          type: 'error'
        });
      }
    },
    submitForm() {
      debounce(async ()=> {
        try{
          this.$refs.formRef.validate()
          let data = await this.$refs.couponsTemplateRef.calibration()
          let templateParams = {
            ...data.templateData,
            appKey: localStorage.getItem("appKeyMini"),
            couponPlatformType: 50,
          }
          console.log(templateParams,'data==couponsTemplateRef')
          await this.$refs.formRef.validate((valid) => {
            if (valid) {
              let params = {}
              params = JSON.parse(JSON.stringify(this.form))
              // 优惠券类型
              if(params.type === 'FIX_VOUCHER') {
                params.discount = ''
                params.ceilingAmount = ''
                params.amount = params.amount * 100
              }else if(params.type === 'DISCOUNT_VOUCHER') {
                params.amount = ''
                params.ceilingAmount = params.ceilingAmount * 100
              }
              // 券使用有效期
              if(params.periodType === 'RELATIVE') {
                params.validTimeArr = []
                params.validBeginTime = ''
                params.validEndTime = ''
              }else if(params.periodType === 'ABSOLUTE') {
                params.waitDaysAfterReceive = ''
                params.validDaysAfterReceive = ''
                params.validBeginTime = params.validTimeArr[0]
                params.validEndTime = params.validTimeArr[1]
              }
              // params.floorAmount = params.floorAmount * 100
              // 活动时间
              params.publishStartTime = params.publishEndTimeArr[0]
              params.publishEndTime = params.publishEndTimeArr[1]
              params.templateVo = templateParams
              params.floorAmount = templateParams.floorAmount
              params.amount = templateParams.couponPrice
              console.log(params,'params====')
              // return
              this.loading = true;
              if(this.typeDialog === 1) {
                this.addCoupon(params)
              }else if(this.typeDialog === 2) {
                params.templateVo.id = this.detaile.templateVo.id
                // 创建失败，重新新建
                if(this.detaile.createStatus === 2) {
                  this.addCoupon(params)
                }else{
                  this.editCoupon(params)
                }
              }
              console.log('提交的数据成功:', this.form);
            } else {
              console.log('表单验证失败!2223');
              return false;
            }
          });
        }catch (err) {
          console.log(err,'ss==err')
        }
      },1000,true)
    },
    async addCoupon(params) {
      console.log('aaaa===')
      const res = await MiniModel.zfbActivityCreateMarket({
        appKey: localStorage.getItem("appKeyMini"),
        ...params,
        id: this.detaile.id ? this.detaile.id : '',
        outBizNo: this.detaile.outBizNo ? this.detaile.outBizNo : ''
      }).finally(() => {
        this.loading = false;
      })
      if(res.data.code === 200) {
        this.$message({
          message: res.data.message,
          type: 'success'
        });
        this.dialogVisible = false;
        this.$emit('refresh')
      }else{
        this.$message({
          message: res.data.message,
          type: 'error'
        });
      }
      console.log(res,'res==1=新增优惠券')
    },
    async editCoupon(params) {
      const res = await MiniModel.zfbActivityEditMarket({
        appKey: localStorage.getItem("appKeyMini"),
        ...this.detaile,
        ...params,
        // id: this.detaile.id,
        // outBizNo: this.detaile.outBizNo ? this.detaile.outBizNo : ''
      }).finally(() => {
        this.loading = false;
      })
      if(res.data.code === 200) {
        this.$message({
          message: res.data.message,
          type: 'success'
        });
        this.dialogVisible = false;
        this.$emit('refresh')
      }else{
        this.$message({
          message: res.data.message,
          type: 'error'
        });
      }
      console.log(res,'res==1=编辑优惠券')
    },
    handelClosed() {
      this.$refs.formRef.resetFields();
      this.typeDialog = ''
      console.log('关闭==')
    },
    handelOpen() {
      // this.resetFrom()
      // this.$refs.formRef.resetFields();
    },
    // 重置
    resetFrom() {
      this.detaile = {}
      this.templateFrom = useCouponsTemplate()
      this.form.type = 'FIX_VOUCHER';
      this.form.activityName = '';
      this.form.publishEndTimeArr = [];
      this.form.floorAmount = '';
      this.form.amount = '';
      this.form.quantity = '';
      this.form.periodType = 'ABSOLUTE';
      this.form.validTimeArr = [];
      this.form.waitDaysAfterReceive = '';
      this.form.validDaysAfterReceive = '';
      this.form.applicableObject = 0;
      this.form.quantityLimitPerUser = '';
      this.form.giveMethod = 0;
      this.form.mutualCondition = 0;
      this.form.refundRule = 0;
      this.form.usePrice = 0;
      this.form.activityStatus = 0;
      this.form.customerServiceMobile = '';
      this.form.remark = '';
      this.form.discount = '';
      this.form.ceilingAmount = '';
    },
    handelChangePeriodType(val) {
      console.log(val,'val==1')
      this.form.validTimeArr = []
      this.form.waitDaysAfterReceive = ''
      this.form.validDaysAfterReceive = '';
      // 单独触发校验
      // this.$refs.formRef.validateField(['validTimeArr','waitDaysAfterReceive','validDaysAfterReceive'], (valid) => {
      //   if (!valid) {
      //     console.log('校验失败');
      //   }
      // });
    },

  }
};
</script>

<style scoped lang="less">
.container{
  //height: 70vh;
  //overflow: auto;
  padding-bottom: 20px;
}
.title{
  font-weight: bold;
  color: #222;
}
.tips{
  color: #666;
  margin-left: 20px;
  font-size: 12px;
}
.item-row /deep/.el-form-item__label{
  color: red;
}
.mtop{
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/zfbMiniProgram/couponGroupNew/component/addCouponZfb.vue